module.exports = __webpack_public_path__ + "img/yt.be825203.svg";